import { render, staticRenderFns } from "./template-edit.vue?vue&type=template&id=0e0c1218"
import script from "./template-edit.vue?vue&type=script&lang=js"
export * from "./template-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports